import { createNamedStyles } from "../../../shared/CreateNamedStyles";

export const PageBodyStyles = createNamedStyles({
  root: {
    margin: 0,
    justifyContent: "center",
  },
});
